import React from 'react';

const ShareComponent = ({ url, title, description }) => {
    const shareOnX = () => {
        const xUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;
        window.open(xUrl, '_blank');
    };

    const shareOnFacebook = () => {
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        window.open(facebookUrl, '_blank');
    };

    const shareOnLinkedIn = () => {
        const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        window.open(linkedInUrl, '_blank');
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(url).then(() => {
            alert('Link copied to clipboard!');
        });
    };

    return (
        <div className="share-component">
            <h6 className="mb-3">Share this:</h6>
            <div className="d-flex gap-2">
                <button 
                    className="btn btn-outline-primary btn-sm"
                    onClick={shareOnX}
                    title="Share on X"
                >
                    <i className="bi bi-twitter-x"></i>
                </button>
                <button 
                    className="btn btn-outline-primary btn-sm"
                    onClick={shareOnFacebook}
                    title="Share on Facebook"
                >
                    <i className="bi bi-facebook"></i>
                </button>
                <button 
                    className="btn btn-outline-primary btn-sm"
                    onClick={shareOnLinkedIn}
                    title="Share on LinkedIn"
                >
                    <i className="bi bi-linkedin"></i>
                </button>
                <button 
                    className="btn btn-outline-secondary btn-sm"
                    onClick={copyToClipboard}
                    title="Copy link"
                >
                    <i className="bi bi-link-45deg"></i>
                </button>
            </div>
        </div>
    );
};

export default ShareComponent;
